import * as yup from 'yup';

export const OrgSchema = yup.object({
  api_phone: yup.string().nullable(),
  class_name: yup.string().nullable(),
  created_tsecs: yup.number().nullable(),
  id: yup.number().defined(),
  is_manufacturer: yup.boolean().nullable(),
  logo_file_id: yup.number().nullable(),
  master_id: yup.number().nullable(),
  name: yup.string().defined(),
  paid: yup.boolean().defined(),
  type: yup.string().nullable(),
  updated_tsecs: yup.number().nullable(),
  uuid: yup.string().uuid().nullable(),
  warranty_claim_email: yup.string().nullable(),
});

export type Org = yup.InferType<typeof OrgSchema>;

export const AllOrgsResponseSchema = yup.object({
  orgs: yup.array(OrgSchema.defined()).defined(),
});

export type AllOrgsResponse = yup.InferType<typeof AllOrgsResponseSchema>;

export const OrgDetailUserSchema = yup.object({
  id: yup.number().nullable(),
  name: yup.string().nullable(),
  email: yup.string().nullable(),
  active: yup.boolean().nullable(),
  roles: yup.array(yup.string().defined()).nullable(),
});

export type OrgDetailUser = yup.InferType<typeof OrgDetailUserSchema>;

export const OrgDetailResponseSchema = yup.object({
  org: OrgSchema.defined(),
  org_users: yup.array(OrgDetailUserSchema.defined()).defined(),
});

export type OrgDetailResponse = yup.InferType<typeof OrgDetailResponseSchema>;

export const SearchOrgsResponseSchema = yup.array(OrgSchema).defined();
export type SearchOrgsResponse = yup.InferType<typeof SearchOrgsResponseSchema>;

export const UpdateOrgResponseSchema = OrgSchema;
export type UpdateOrgResponse = Org;

export interface UpdateOrgRequest {
  name: string;
}
